// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1GQ5S","label":"Radio_label__2AGTc","checkMark":"Radio_checkMark__2qnGB","disabled":"Radio_disabled__1Kz5X"};